import styled from "@emotion/styled";
import { AnimatePresence, m } from "framer-motion";
import React from "react";

import { NAV_HEIGHT } from "../../consts";

const BackdropElement = styled(m.div)(({ theme }) => ({
  position: "fixed",
  background: "rgba(0,0,0,0.3)",
  backdropFilter: "blur(3px)",
  top: NAV_HEIGHT,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: theme.zIndex.HEADER - 1,
}));

interface Props {
  isActive?: boolean;
  className?: string;
}

export function Backdrop({ isActive, className }: Props) {
  return (
    <AnimatePresence>
      {isActive && (
        <BackdropElement
          className={className}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ opacity: { duration: 0.2 } }}
        />
      )}
    </AnimatePresence>
  );
}
